import styled from 'styled-components';
import { theme, toRem } from 'design';

const PageHeaderAvatarLayout = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${toRem(theme.space.md)};
  justify-items: center;
  width: 100%;

  @media (min-width: ${theme.breakpoint.small}px) {
    display: flex;
    grid-gap: 0;
    flex-grow: 1;
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: center;
    width: auto;
  }

  h1 {
    margin-bottom: 0;
  }
`;

export default PageHeaderAvatarLayout;
